export const getDefaultSort = (options) => {
    if (
        options.searchQuery === '' &&
        options.contentType &&
        options.contentType.length === 1 &&
        (options.contentType.filter((f) => f === 'podcasts').length === 1 ||
            options.contentType.filter((f) => f === 'post').length === 1 ||
            options.contentType.filter((f) => f === 'webinars').length === 1 ||
            options.contentType.filter((f) => f === 'analyst_reports').length === 1)
    ) {
        return 'date';
    }

    return 'relevance';
};

export const buildURL = (searchOptions) => {
    if (!searchOptions) return '';

    let queryString = [];

    if (searchOptions.searchQuery) queryString.push(`q=${searchOptions.searchQuery}`);
    if (searchOptions.licensing_Tech?.length)
        queryString.push(`tech=${searchOptions.licensing_Tech.join(',')}`);
    if (searchOptions.products?.length) queryString.push(`ms=${searchOptions.products.join(',')}`);
    if (searchOptions.cloud_OnPremises_Hybrid?.length)
        queryString.push(`c=${searchOptions.cloud_OnPremises_Hybrid.join(',')}`);
    if (searchOptions.contentType?.length)
        queryString.push(`ct=${searchOptions.contentType.join(',')}`);
    if (searchOptions.mediaType?.length)
        queryString.push(`mt=${searchOptions.mediaType.join(',')}`);
    if (searchOptions.subjectArea?.length)
        queryString.push(`sa=${searchOptions.subjectArea.join(',')}`);
    if (searchOptions.datePublishedPreset)
        queryString.push(`dp=${searchOptions.datePublishedPreset}`);
    if (searchOptions.datePublishedStart)
        queryString.push(`df=${searchOptions.datePublishedStart}`);
    if (searchOptions.datePublishedEnd) queryString.push(`dt=${searchOptions.datePublishedEnd}`);
    if (searchOptions.authors?.length) queryString.push(`auth=${searchOptions.authors.join(',')}`);
    if (searchOptions.archived) queryString.push('ar=true');

    if (
        searchOptions.total &&
        parseInt(searchOptions.total) !== 8 &&
        parseInt(searchOptions.total) !== 24
    )
        queryString.push(`total=${parseInt(searchOptions.total)}`);
    if (searchOptions.expandSearch) queryString.push('expand=true');
    if (searchOptions.score) queryString.push('score=true');
    if (!searchOptions.popularity) queryString.push('popularity=false');
    if (searchOptions.overrideReplacement) queryString.push('override=true');

    let defaultSort = getDefaultSort(searchOptions);
    if (searchOptions.sortBy && searchOptions.sortBy !== defaultSort)
        queryString.push(`sort=${searchOptions.sortBy}`);

    return queryString.join('&');
};

export const buildSearchObj = (params) => {
    const parseArrayParam = (param) => (param ? param.split(',') : null);
    let contentType = parseArrayParam(params.get('ct'));

    // Support both 'q' (React search) and 's' (WordPress default) parameters
    const searchQuery = params.get('q') || params.get('s') || '';

    let options = {
        searchQuery: searchQuery,
        licensing_Tech: parseArrayParam(params.get('tech')),
        products: parseArrayParam(params.get('ms')),
        cloud_OnPremises_Hybrid: parseArrayParam(params.get('c')),
        contentType: parseArrayParam(params.get('ct')),
        mediaType: parseArrayParam(params.get('mt')),
        subjectArea: parseArrayParam(params.get('sa')),
        datePublishedPreset: params.get('dp') || '',
        datePublishedStart: params.get('df') || '',
        datePublishedEnd: params.get('dt') || '',
        authors: parseArrayParam(params.get('auth')),
        archived: params.get('ar') || false,
        expandSearch: params.get('expand') || false,
        skip: params.get('skip') || 0,
        take: params.get('total') || params.get('take') || 8,
        score: params.get('score') || false,
        popularity: params.get('popularity') || true,
        showExplain: params.get('score') || false,
        overrideReplacement: params.get('override') || false,
        searchType:
            contentType && contentType.length === 1 && contentType.includes('infographics') ? 2 : 0,
    };

    let defaultSort = getDefaultSort(options);
    options = { ...options, sortBy: params.get('sort') || defaultSort };

    return options;
};

export const filterCount = async (searchOptions) => {
    let count = 0;

    if (searchOptions.licensing_Tech) {
        count += searchOptions.licensing_Tech.length;
    }
    if (searchOptions.products) {
        count += searchOptions.products.length;
    }
    if (searchOptions.cloud_OnPremises_Hybrid) {
        count += searchOptions.cloud_OnPremises_Hybrid.length;
    }
    if (searchOptions.contentType) {
        count += searchOptions.contentType.length;
    }
    if (searchOptions.mediaType) {
        count += searchOptions.mediaType.length;
    }
    if (searchOptions.subjectArea) {
        count += searchOptions.subjectArea.length;
    }
    if (
        searchOptions.datePublishedPreset ||
        searchOptions.datePublishedStart ||
        searchOptions.datePublishedEnd
    ) {
        count += 1;
    }
    if (searchOptions.authors) {
        count += searchOptions.authors.length;
    }
    if (searchOptions.archived) {
        count += 1;
    }
    return count;
};

export const contentFilters = async (searchResults, filters, options) => {
    // If we haven't gotten all filters then do it
    if (!filters || !filters.product) {
        let results = null; //await getContentFilters(options);
        filters = results?.data;
    }

    return processContentFilters(searchResults, filters, options);
};

export const processContentFilters = (searchResults, filters, options) => {
    if (filters && filters.product && options) {
        let updateResults = updateFilterList(
            filters.product,
            options.products,
            undefined,
            undefined
        );
        filters = { ...filters, product: updateResults.filters };
    }

    if (filters && filters.subjectArea && options) {
        let updateResults = updateFilterList(
            filters.subjectArea,
            options.subjectArea,
            undefined,
            undefined
        );
        filters = { ...filters, subjectArea: updateResults.filters };
    }

    // Update licensing Tech Counts
    filters &&
        filters.licensing_Tech &&
        filters.licensing_Tech.forEach((filterItem) => {
            if (
                searchResults &&
                searchResults.licensing_Tech &&
                searchResults.licensing_Tech.find((x) => x.id === filterItem.id)
            ) {
                filterItem.count =
                    searchResults.licensing_Tech &&
                    searchResults.licensing_Tech.find((x) => x.id === filterItem.id).count;
            } else {
                filterItem.count = 0;
            }
        });

    // Update Summary Subject Area Counts
    filters &&
        filters.subjectArea &&
        filters.subjectArea.forEach((filterItem) => {
            const searchResult1 =
                searchResults &&
                searchResults.subjectArea &&
                searchResults.subjectArea.find((x) => x.id === filterItem.id);
            if (searchResult1) {
                filterItem.count = searchResult1.count;
            } else {
                filterItem.count = 0;
            }

            // Update Subject Area Counts
            filterItem &&
                filterItem.filters &&
                filterItem.filters.forEach((filterItemSub) => {
                    const searchResult2 =
                        searchResult1 &&
                        searchResult1.filters.find((x) => x.id === filterItemSub.id);
                    if (searchResult2) {
                        filterItemSub.count = searchResult2.count;
                    } else {
                        filterItemSub.count = 0;
                    }
                });
        });

    // Update MS Product Family Counts
    filters &&
        filters.product &&
        filters.product.forEach((filterItem) => {
            const searchResult1 =
                searchResults &&
                searchResults.product &&
                searchResults.product.find((x) => x.id === filterItem.id);
            if (searchResult1) {
                filterItem.count = searchResult1.count;
            } else {
                filterItem.count = 0;
            }

            // Update MS Product Counts
            filterItem &&
                filterItem.filters &&
                filterItem.filters.forEach((filterItemSub) => {
                    const searchResult2 =
                        searchResult1 &&
                        searchResult1.filters.find((x) => x.id === filterItemSub.id);
                    if (searchResult2) {
                        filterItemSub.count = searchResult2.count;
                    } else {
                        filterItemSub.count = 0;
                    }
                });
        });

    // Update cloud/On Premises/Hybrid Counts
    filters &&
        filters.cloud_OnPremises_Hybrid &&
        filters.cloud_OnPremises_Hybrid.forEach((filterItem) => {
            if (
                searchResults &&
                searchResults.cloud_OnPremises_Hybrid &&
                searchResults.cloud_OnPremises_Hybrid.find((x) => x.id === filterItem.id)
            ) {
                filterItem.count =
                    searchResults.cloud_OnPremises_Hybrid &&
                    searchResults.cloud_OnPremises_Hybrid.find((x) => x.id === filterItem.id).count;
            } else {
                filterItem.count = 0;
            }
        });

    // Update Content Type Counts
    filters &&
        filters.contentType &&
        filters.contentType.forEach((filterItem) => {
            if (
                searchResults &&
                searchResults.contentType &&
                searchResults.contentType.find((x) => x.id === filterItem.id)
            ) {
                filterItem.count =
                    searchResults.contentType &&
                    searchResults.contentType.find((x) => x.id === filterItem.id).count;
            } else {
                filterItem.count = 0;
            }
        });

    // Update Media Type Counts
    filters &&
        filters.mediaType &&
        filters.mediaType.forEach((filterItem) => {
            if (
                searchResults &&
                searchResults.mediaType &&
                searchResults.mediaType.find((x) => x.id === filterItem.id)
            ) {
                filterItem.count =
                    searchResults.mediaType &&
                    searchResults.mediaType.find((x) => x.id === filterItem.id).count;
            } else {
                filterItem.count = 0;
            }
        });

    // Update Authors Counts
    filters &&
        filters.authors &&
        filters.authors.forEach((filterItem) => {
            if (
                searchResults &&
                searchResults.authors &&
                searchResults.authors.find((x) => x.id === filterItem.id)
            ) {
                filterItem.count =
                    searchResults.authors &&
                    searchResults.authors.find((x) => x.id === filterItem.id).count;
            } else {
                filterItem.count = 0;
            }
        });

    // Update Archived Counts
    filters &&
        filters.archived &&
        filters.archived.forEach((filterItem) => {
            if (
                searchResults &&
                searchResults.archived &&
                searchResults.archived.find((x) => x.id === 'archived-true')
            ) {
                filterItem.count =
                    searchResults.archived &&
                    searchResults.archived.find((x) => x.id === filterItem.id).count;
            } else {
                filterItem.count = 0;
            }
        });

    return filters;
};

export const updateFilterList = (filters, selected, id, checked) => {
    if (id !== undefined && checked !== undefined) {
        selected = updateSelected(filters, selected, id, checked);
    }
    filters = updateCheckedState(filters, selected, false);
    return {
        selected,
        filters,
    };
};

const updateSelected = (filters, selected, id, checked) => {
    selected = [...selected];
    filters.map((prodFam) => {
        if (prodFam.id === id) {
            if (checked) {
                selected.push(prodFam.id);
                prodFam = { ...prodFam, checked: true };
            } else {
                selected = selected.filter((s) => s !== prodFam.id);
                prodFam = { ...prodFam, checked: false };
            }
        } else if (selected.includes(prodFam.id)) {
            prodFam = { ...prodFam, checked: true };
        } else {
            selected = selected.filter((s) => s !== prodFam.id);
            prodFam = { ...prodFam, checked: false };
        }

        let prodFamFiltersAll = true;
        prodFam.filters.map((prod) => {
            if (prod.id === id) {
                if (checked) {
                    selected.push(prod.id);
                    prod = { ...prod, checked: true };
                } else {
                    selected = selected.filter((s) => s !== prodFam.id && s !== prod.id);
                    prod = { ...prod, checked: false };
                    prodFamFiltersAll = false;

                    if (prodFam.checked) {
                        prodFam.filters
                            .filter((f) => f.id !== prod.id)
                            .map((pushFilter) => {
                                if (selected.filter((s) => s === pushFilter.id).length === 0) {
                                    selected.push(pushFilter.id);
                                }
                            });
                    }
                }
            } else if (prodFam.checked || selected.includes(prod.id)) {
                prod = { ...prod, checked: true };
            } else {
                prod = { ...prod, checked: false };
                prodFamFiltersAll = false;
            }
        });

        // Check if all are selected
        if (prodFam.filters && prodFam.filters.length > 0 && prodFamFiltersAll) {
            // Remove all
            prodFam.filters.map((prod) => {
                selected = selected.filter((s) => s !== prod.id);
            });

            if (selected.filter((s) => s === prodFam.id).length === 0) {
                selected.push(prodFam.id);
            }
        }
    });

    return selected;
};

const updateCheckedState = (filters, selected, checked) => {
    return filters.map((filter) => {
        if (selected && selected.includes(filter.id)) {
            let childFilters = updateCheckedState(filter.filters, selected, true);
            let childrenStatus =
                childFilters &&
                (childFilters.filter((f) => f.checked).length === childFilters.length
                    ? 'all'
                    : childFilters.filter((f) => !f.checked).length === childFilters.length
                      ? 'none'
                      : 'some');

            // If selected then set item checked as well as all children
            return {
                ...filter,
                checked: childrenStatus === 'all' ? true : true,
                children: childrenStatus,
                filters: childFilters,
            };
        } else if (filter.filters && filter.filters.length > 0) {
            let childFilters = updateCheckedState(filter.filters, selected, checked);
            let childrenStatus =
                childFilters &&
                (childFilters.filter((f) => f.checked).length === childFilters.length
                    ? 'all'
                    : childFilters.filter((f) => !f.checked).length === childFilters.length
                      ? 'none'
                      : 'some');

            // If not selected then set to checked value passed in and traverse children
            return {
                ...filter,
                checked: childrenStatus === 'all' ? true : checked,
                children: childrenStatus,
                filters: childFilters,
            };
        } else {
            // If item has no children then set to passed in checked value
            return { ...filter, checked, children: 'none' };
        }
    });
};

export const explanationObjectBreakdown = (hitExplanation) => {
    let explanationObj = {},
        breakdown = '';

    breakdown = explanationBreakdown(explanationObj, hitExplanation, 0);
    explanationObj.explanation = breakdown;
    return explanationObj;
};

const explanationBreakdown = (explanationObj, explanation, level = 0) => {
    let result = '';

    if (!explanation) return '';

    if (Array.isArray(explanation)) {
        explanation.map((details) => {
            result += explanationDetails(explanationObj, details, level);
        });
    } else {
        result += explanationDetails(explanationObj, explanation, level);
    }

    return result;
};

const explanationDetails = (explanationObj, detailsObj, level) => {
    let result = '';

    if (!detailsObj) return '';

    if (!explanationObj.score && detailsObj.description.startsWith('function score, product of:')) {
        explanationObj.score = Intl.NumberFormat('en-US', { style: 'decimal' }).format(
            detailsObj.value
        );
    } else if (
        explanationObj.score &&
        !explanationObj.boostScore &&
        detailsObj.description.startsWith('function score, product of:')
    ) {
        explanationObj.boostScore = Intl.NumberFormat('en-US', { style: 'decimal' }).format(
            detailsObj.value
        );
    } else if (
        explanationObj.score &&
        !explanationObj.matchScore &&
        detailsObj.description === 'sum of:'
    ) {
        explanationObj.matchScore = Intl.NumberFormat('en-US', { style: 'decimal' }).format(
            detailsObj.value
        );
    } else if (
        !explanationObj.boostingQueryScore &&
        detailsObj.description === 'function score, score mode [min]'
    ) {
        explanationObj.boostingQueryScore = Intl.NumberFormat('en-US', { style: 'decimal' }).format(
            detailsObj.value
        );
    } else if (
        !explanationObj.popularityMultiplier &&
        detailsObj.description === 'function score, score mode [sum]'
    ) {
        explanationObj.popularityMultiplier = Intl.NumberFormat('en-US', {
            style: 'decimal',
        }).format(detailsObj.value);
    }

    // Adding tabs for the current level
    result += '\t'.repeat(level);
    result += `(${Intl.NumberFormat('en-US', { style: 'decimal' }).format(detailsObj.value)}) -> ${detailsObj.description}`;
    result += '\n';

    result += explanationBreakdown(explanationObj, detailsObj.details, level + 1);

    return result;
};

export const getActiveFilters = (allFilters, searchOptions) => {
    const filters = [];

    // Licensing/Tech Content
    allFilters &&
        searchOptions &&
        searchOptions.licensing_Tech &&
        searchOptions.licensing_Tech.map((item) => {
            const filter = allFilters.licensing_Tech?.find((f) => f.id === item);
            if (filter) {
                filters.push({
                    key: `tech_${filter.id}`,
                    id: filter.id,
                    name: filter.name,
                    type: 'tech',
                });
            }
        });

    // MS Product
    allFilters &&
        allFilters.product &&
        searchOptions?.products?.map((item) => {
            let filter = allFilters.product?.find((f) => f.id === item);
            if (filter) {
                filters.push({
                    key: `ms_${filter.id}`,
                    id: filter.id,
                    name: filter.name,
                    type: 'ms',
                });
            } else {
                allFilters.product.map((subProduct) => {
                    filter = subProduct.filters.find((f) => f.id === item);

                    if (filter) {
                        filters.push({
                            key: `ms_${filter.id}`,
                            id: filter.id,
                            name: `${subProduct.name}: ${filter.name}`,
                            type: 'ms',
                        });
                    } else {
                        subProduct.filters.map((category) => {
                            filter = category.filters.find((f) => f.id === item);

                            if (filter) {
                                filters.push({
                                    key: `ms_${filter.id}`,
                                    id: filter.id,
                                    name: filter.name,
                                    type: 'ms',
                                });
                            }
                        });
                    }
                });
            }
        });

    // Cloud/On-Premises/Hybrid/Edge
    allFilters &&
        allFilters.cloud_OnPremises_Hybrid &&
        searchOptions?.cloud_OnPremises_Hybrid?.map((item) => {
            const filter = allFilters.cloud_OnPremises_Hybrid?.find((f) => f.id === item);
            if (filter) {
                filters.push({
                    key: `c_${filter.id}`,
                    id: filter.id,
                    name: filter.name,
                    type: 'c',
                });
            }
        });

    // Content Type
    allFilters &&
        allFilters.contentType &&
        searchOptions?.contentType?.map((item) => {
            const filter = allFilters.contentType?.find((f) => f.id === item);
            if (filter) {
                filters.push({
                    key: `ct_${filter.id}`,
                    id: filter.id,
                    name: filter.name,
                    type: 'ct',
                });
            }
        });

    // Media Type
    allFilters &&
        allFilters.mediaType &&
        searchOptions?.mediaType?.map((item) => {
            const filter = allFilters.mediaType?.find((f) => f.id === item);
            if (filter) {
                filters.push({
                    key: `mt_${filter.id}`,
                    id: filter.id,
                    name: filter.name,
                    type: 'mt',
                });
            }
        });

    // Subject Area
    allFilters &&
        allFilters.subjectArea &&
        searchOptions?.subjectArea?.map((item) => {
            let filter = allFilters.subjectArea?.find((f) => f.id === item);
            if (filter) {
                filters.push({
                    key: `sa_${filter.id}`,
                    id: filter.id,
                    name: filter.name,
                    type: 'sa',
                });
            } else {
                allFilters.subjectArea.map((subCategory) => {
                    filter = subCategory.filters.find((f) => f.id === item);

                    if (filter) {
                        filters.push({
                            key: `sa_${filter.id}`,
                            id: filter.id,
                            name: `${subCategory.name}: ${filter.name}`,
                            type: 'sa',
                        });
                    } else {
                        subCategory.filters.map((category) => {
                            filter = category.filters.find((f) => f.id === item);

                            if (filter) {
                                filters.push({
                                    key: `sa_${filter.id}`,
                                    id: filter.id,
                                    name: `${category.name}: ${filter.name}`,
                                    type: 'sa',
                                });
                            }
                        });
                    }
                });
            }
        });

    // authors
    allFilters &&
        allFilters.authors &&
        searchOptions?.authors?.map((item) => {
            const filter = allFilters.authors?.find((f) => f.id === item);
            if (filter) {
                filters.push({
                    key: `auth_${filter.id}`,
                    id: filter.id,
                    name: filter.name,
                    type: 'auth',
                });
            }
        });

    if (
        searchOptions?.archived &&
        (searchOptions?.archived === 'true' || searchOptions?.archived === true)
    ) {
        filters.push({
            key: 'archived-true',
            id: 'archived-true',
            name: 'Include Archived Content',
            type: 'ar',
        });
    }

    // Date Preset
    if (allFilters && searchOptions?.datePublishedPreset) {
        if (searchOptions?.datePublishedPreset != 'custom') {
            let preset_display = '';
            switch (searchOptions?.datePublishedPreset) {
                case 'today':
                    preset_display = 'Today';
                    break;
                case 'yesterday':
                    preset_display = 'Yesterday';
                    break;
                case 'thisWeek':
                    preset_display = 'This Week';
                    break;
                case 'lastWeek':
                    preset_display = 'Last Week';
                    break;
                case 'thisMonth':
                    preset_display = 'This Month';
                    break;
                case 'lastMonth':
                    preset_display = 'Last Month';
                    break;
                case 'ytd':
                    preset_display = 'Year to Date';
                    break;
                default:
                    preset_display = 'Custom';
            }
            filters.push({
                key: `dp_${searchOptions?.datePublishedPreset}`,
                id: searchOptions?.datePublishedPreset,
                name: `Date preset (${preset_display})`,
                type: 'dp',
            });
        }
    }

    if (!searchOptions?.datePublishedPreset || searchOptions?.datePublishedPreset == 'custom') {
        // Date From
        if (allFilters && searchOptions?.datePublishedStart) {
            filters.push({
                key: `df_${searchOptions?.datePublishedStart}`,
                id: searchOptions?.datePublishedStart,
                name: `Start Date (${searchOptions?.datePublishedStart})`,
                type: 'df',
            });
        }
        // Date To
        if (allFilters && searchOptions?.datePublishedEnd) {
            filters.push({
                key: `dt_${searchOptions?.datePublishedEnd}`,
                id: searchOptions?.datePublishedEnd,
                name: `End Date (${searchOptions?.datePublishedEnd})`,
                type: 'dt',
            });
        }
    }

    return filters;
};
